export const DEFAULT_HOUSE_RULES = {
    stackDrawTwo: false,
    stackDrawFour: false,
    crossStack: false,
    reverseDeflectDrawTwo: false,
    reverseDeflectDrawFour: false,
    skipDeflect: false,
    zeroRotateHands: false,
    sevenSwapHands: false,
    jumpIn: false,
    multiplePlaySameNumber: false,
    wildFirstTurn: false,
    drawUntilPlayable: false,
    forcedPlayAfterDraw: false,
    handLimit: null,
    forcedPlay: false,
    handRevealThreshold: null,
    unoPenaltyCount: 2,
    strictUnoCall: false,
    misplayPenalty: false,
    fastMode: false,
    noHints: false,
    elimination: false,
    blitzTimeLimit: null,
    revengeMode: false,
    silentUno: false,
    teamMode: false,
    noFunctionCardFinish: false,
    noWildFinish: false,
    doubleScore: false,
    noChallengeWildFour: false,
    blindDraw: false,
    bombCard: false,
    shuffleSeats: false,
};
export const HOUSE_RULES_PRESETS = {
    classic: {},
    party: {
        stackDrawTwo: true,
        stackDrawFour: true,
        zeroRotateHands: true,
        sevenSwapHands: true,
        jumpIn: true,
        drawUntilPlayable: true,
    },
    crazy: {
        stackDrawTwo: true,
        stackDrawFour: true,
        crossStack: true,
        reverseDeflectDrawTwo: true,
        reverseDeflectDrawFour: true,
        skipDeflect: true,
        zeroRotateHands: true,
        sevenSwapHands: true,
        jumpIn: true,
        multiplePlaySameNumber: true,
        drawUntilPlayable: true,
        forcedPlayAfterDraw: true,
        doubleScore: true,
        noChallengeWildFour: true,
    },
};
//# sourceMappingURL=house-rules.js.map